define('views/product-block-view',['utils/view', 'connections/product-block-connection'], function(
  View,
  ProductBlockConnection
) {
  var ProductBlockView = (function() {
    function ProductBlockView(container) {
      this.$container = container;
      this.blockId = container.data('blockid');
    }

    ProductBlockView.prototype.loadContent = function() {
      var self = this;
      ProductBlockConnection.getProductBlock(self.blockId).then(function(res) {
        self.$container.html(res);
        window.productCardAddToCart.resetMatrices();
        window.LazyLoadInstance.update();
        window.updateVisiblePrices();
      });
    };

    return ProductBlockView;
  })();

  return View('ProductBlockView', function() {
    $('[data-view="ProductBlockView"]').each(function() {
      var pbv = new ProductBlockView($(this));
      pbv.loadContent();
    });
  });
});

